module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABAElEQVQ4jdWSPU7DQBCF34zXkRB0OYLLFHCDXAAJKlJQkFOstTdAXucYiFCAQOECoUY0tOEg62VnaBILRbLjEl756c3/AP9edMhQluUkpXQJoCCikapumPm1qqr3NoFzbpxSmovIKYCjQZWJnrz39+ScGzdNUxPRSYf3G8DSGPMGADHGKRHNABhVvTUppXlPMFT1YbFYvPxCz9ZaiMg1EZ3ztu1O5Xm+3mfMvGMF9w7aoRBCu3xm5s8+s4hM91mWZTv2ZQDcAZgAOO5IMLPWgpnXIQTaBl8BABGt2jPGGG8AnGHgGQE81nW9HPRIInIBoFDVEYANEa289x8DC/11/QBXRGBV/HvTqwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ao-toggle-on.png
// module id = 320
// module chunks = 0